<div *ngIf="certInfo$ | async as certInfo">
  <h2>Sækja skilríki</h2>
  <ng-container *ngIf="!certInfo.used; else certUsedTemplate">
    <p>
      Smelltu á hnappinn til að sækja skilríkið þitt
      <i>({{ certInfo.subject }})</i>.
    </p>
    <p>
      <strong
        >Athugaðu að það er eingöngu hægt að sækja skrána einu sinni</strong
      >
      og því er best að opna þennan hlekk í því tæki sem ætlunin er að setja
      skilríkið upp á.
    </p>
    <a
      href="/api/certificate"
      [download]="certInfo.subject + '.pfx'"
      mat-raised-button
      color="primary"
      *ngIf="!clicked; else doneButton"
      (click)="getCert()"
    >
      Sækja skrá
    </a>
    <ng-template #doneButton>
      <p>
        <button disabled color="primary" mat-raised-button>
          <mat-icon>check_outline</mat-icon>
        </button>
        <span id="passwordText">
          <ng-container *ngIf="certPass$ | async as certPass; else loading">
            Lykilorð skilríkisins:
            <div>
              <span>
                <input
                  #keyCopy
                  (click)="keyCopy.select()"
                  [value]="certPass.key"
                  readonly
                />
              </span>
              <button
                mat-raised-button
                color="primary"
                (click)="copy(certPass.key)"
                type="button"
              >
                Afrita
              </button>
            </div>
          </ng-container>
        </span>

        <ng-template #loading>
          <mat-progress-bar mode="buffer"></mat-progress-bar>
        </ng-template>
      </p>
    </ng-template>
  </ng-container>
  <ng-template #certUsedTemplate>
    <p>
      Búið er að sækja skilríki og lykilorð fyrir þennan lykil.
      <ng-container *ngIf="!clicked">Á eftir að setja það upp? </ng-container
      ><button
        mat-button
        color="primary"
        [style.opacity]="clicked ? 0 : 1"
        [disabled]="clicked"
        (click)="clicked = true"
      >
        Leiðbeiningar
      </button>
    </p>
  </ng-template>

  <app-certificate-instructions
    *ngIf="clicked"
    [certInfo]="certInfo"
  ></app-certificate-instructions>
</div>
